import React, { useEffect, useState } from "react";
import CSApiCode from "../../images/API-code.png";
import CSApiCodeMobile from "../../images/API-code-mobile.png";
import InView from "react-intersection-observer";
import HeaderAnim from "../common/utils/animations/textRevealAnimation";

export default function CsDesignSystem() {
  const [isMobile, setisMobile] = useState(false);
  const [isVisible, setisVisible] = useState(false);
  useEffect(() => {
    const setValues = () => {
      setisMobile(window.innerWidth <= 767);
    };
    setValues();
    window.addEventListener('resize', () => {
      setValues();
    });
    return () => {
      window.removeEventListener('resize', () => {
        setValues();
      });
    };
  });


  return (
    <div className="cs-api-platform-section section-gap">
      <div className="container">
        <InView as="div" className="row d-flex flex-wrap" onChange={(inVIew) => setisVisible(inVIew)}>
          <div className="col cs-api-platform-content">
            <p className="theme-color-title blue-color">{isVisible ? <HeaderAnim header="API-FIRST PLATFORM" /> : ""}</p>
            <h2 className="h3">Powerful and easy-to-use APIs & SDK for building custom apps</h2>
            <p>API-first approach is non-negotiable for enabling rapid integrations and customizations needed to create seamless customer and sales experiences.</p>

            <p>With 750+ REST APIs to webhooks and native components, we built a solid API backbone that powers Salesmate’s web, mobile, chrome apps. It also allowed sales to shipping new features at a lighting speed and enabled hundreds of built-in custom integrations for its customers.</p>

            <p>Here are a few highlights of the Salesmate API platform features that we built:</p>
            <ul>
              <li>API rate limits for usage-based billing and prevent attacks</li>
              <li>OAuth-based authentication & authorization</li>
              <li>API versioning and seamless migration </li>
              <li>Webhook integrations & SDK for third-party apps</li>
              <li>Auto-generated documentation and code examples</li>
              <li>API monitoring & product analytics  </li>
            </ul>
          </div>

          <div className="col cs-api-platform-image">
            {!isMobile && <>
              <img src={CSApiCode} width="690px" className="cb-api-platform" title=" powerful api" alt=" powerful api" />
            </>}
            {isMobile && <>
              <img src={CSApiCodeMobile} className="cb-api-platform" title=" powerful api" alt=" powerful api" />
            </>}
          </div>
        </InView>
      </div>
    </div>
  );
}